export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20soft%20amber%20spotlight%20beams%20and%20floating%20golden%20dust%20particles%2C%20abstract%20film%20texture%20with%20subtle%20grain%2C%20elegant%20movie%20theater%20ambiance%20with%20deep%20shadows%20and%20warm%20highlights%2C%20no%20text%20or%20people%2C%20atmospheric%20and%20artistic&width=1920&height=900&seq=hero-bg-6080&orientation=landscape"
          alt="6080新视觉影院 影院氛围背景"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50/90"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/15 text-primary-400 rounded-full border border-primary-500/20 mb-4 whitespace-nowrap">
              不缓冲 · 极速秒开 · 流畅播放
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-3">
              6080新视觉影院
              <br />
              <span className="text-primary-400">高清影视免费在线观看</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-300 font-heading font-medium mb-6">
              全集不卡顿，畅享观影新体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              6080新视觉影院汇聚海量高清电影电视剧资源，采用先进的智能加速技术，实现不缓冲极速秒开播放体验。无论是最新上映的院线大片，还是经典怀旧的全集电视剧，这里都能免费在线观看，真正告别卡顿与等待。每日持续更新热门内容，覆盖动作、喜剧、悬疑、科幻等多种类型，是您掌上的免费影视大全。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-flashlight-line text-primary-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-500">日更 <strong className="text-primary-400 font-semibold">200+</strong> 部资源</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/10">
                  <i className="ri-speed-up-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-500">平均加载 <strong className="text-accent-400 font-semibold">&lt;0.8</strong> 秒</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/10">
                  <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-500">安全纯净 <strong className="text-secondary-400 font-semibold">无广告</strong> 干扰</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-foreground-950 font-semibold text-sm rounded-md hover:bg-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-600 font-medium text-sm rounded-md border border-background-300/40 hover:border-primary-500/30 hover:text-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20composition%20with%20floating%20golden%20film%20reels%20and%20warm%20amber%20spotlight%20on%20dark%20background%2C%20classic%20movie%20theater%20atmosphere%20with%20soft%20bokeh%20light%20particles%2C%20dramatic%20lighting%20with%20elegant%20shadow%20play%2C%20no%20text%20or%20people%2C%20artistic%20and%20luxurious%20film%20aesthetic%2C%208k%20quality%20cinematic%20still&width=800&height=600&seq=hero-visual-6080&orientation=landscape"
                alt="6080新视觉影院 电影主题视觉"
                className="w-full h-full object-cover object-center rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg border border-background-200/30 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}